import { getSelectedDate, getSelectedDistrict, getSelectedState } from 'app/imports/App.selectors'
import { cszUrl } from 'features/Env'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export function useScoresLink(sportIds?: string[]) {
  const selectedState = useSelector(getSelectedState)
  const selectedDistrict = useSelector(getSelectedDistrict)
  const selectedDate = useSelector(getSelectedDate)

  const scoresUrl = useMemo(() => {
    if (
      (selectedState && selectedState.length > 1) ||
      (selectedDistrict && selectedDistrict.length > 1) ||
      (sportIds && sportIds.length > 1)
    ) {
      return `${cszUrl}/scores?force=true`
    }

    const queryParams = [`selectedDate=${selectedDate}`]

    if (selectedState && selectedState.length === 1) {
      queryParams.push(`selectedStateId=${selectedState[0].id}`)
    }

    if (selectedDistrict && selectedDistrict.length === 1) {
      queryParams.push(`selectedCountyId=${selectedDistrict[0].id}`)
    }

    if (sportIds && sportIds.length === 1) {
      queryParams.push(`selectedSportId=${sportIds[0]}`)
    }

    queryParams.push('force=true')

    return `${cszUrl}/scores?${queryParams.join('&')}`
  }, [selectedDate, selectedDistrict, selectedState, sportIds])

  return { scoresUrl }
}
